import BasicInfo from "./partials/BasicInfo";
import ExperienceSkills from "./partials/ExperienceSkills";

const StepOne = () => {
  return (
    <div className="max-h-full w-full flex text-sm xl:text-lg mt-4">
      <BasicInfo />
      <ExperienceSkills />
    </div>
  );
};

export default StepOne;
